import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ConceptSection from '../components/ConceptSection';
import HistorySection from '../components/HistorySection';
import MenuSection from '../components/MenuSection';
import TeamSection from '../components/TeamSection';
import ReservationSection from '../components/ReservationSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import WelcomePopup from '../components/WelcomePopup';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <MenuSection />
      <ConceptSection />
      <TeamSection />
      <HistorySection />
      <ReservationSection />
      <ContactSection />
      <Footer />
      <WelcomePopup />
    </div>
  );
};

export default Home;